// src/components/BTDLandingPage.js
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ChevronLeft } from 'lucide-react';

function BTDLandingPage() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen">
      {/* Navigation Header */}
      <nav className="bg-white shadow-md sticky top-0 z-10">
        <div className="max-w-4xl mx-auto px-4">
          <div className="flex items-center h-16">
            <button
              onClick={() => navigate('/')}
              className="text-blue-600 hover:text-blue-800 flex items-center gap-2 transition-colors"
            >
              <ChevronLeft size={20} />
              <span>Back to Main</span>
            </button>
            <h1 className="text-xl font-bold text-blue-900 flex-1 text-center">
              BTD Research Paper
            </h1>
            <div className="w-24"></div> {/* Spacer for alignment */}
          </div>
        </div>
      </nav>

      {/* Main Content */}
      <div className="max-w-4xl mx-auto p-6">
        {/* Introduction */}
        <div className="text-center mb-8">
          <h2 className="text-2xl font-bold text-blue-900 mb-4">
            Explore Bidirectional Time Divergence Research
          </h2>
          <p className="text-gray-600 max-w-2xl mx-auto">
            Discover my research connecting quantum physics and artificial intelligence 
            through the lens of bidirectional time.
          </p>
        </div>

        {/* Section Cards */}
        <div className="grid gap-6 md:grid-cols-2">
          {/* BTD Theory Card */}
          <div 
            onClick={() => navigate('/btd/theory')}
            className="bg-white p-6 rounded-lg shadow-md cursor-pointer 
                     hover:shadow-lg transition-all duration-300 
                     transform hover:scale-[1.02] hover:bg-blue-50"
          >
            <h2 className="text-xl font-semibold text-blue-800 mb-3">
              BTD Theory
            </h2>
            <p className="text-gray-600 mb-4">
              Core theoretical framework and mathematical foundations of 
              Bidirectional Time Divergence.
            </p>
            <div className="text-blue-600 text-sm">
              Explore theoretical foundations →
            </div>
          </div>

          {/* AGI Applications Card */}
          <div 
            onClick={() => navigate('/btd/agi')}
            className="bg-white p-6 rounded-lg shadow-md cursor-pointer 
                     hover:shadow-lg transition-all duration-300 
                     transform hover:scale-[1.02] hover:bg-blue-50"
          >
            <h2 className="text-xl font-semibold text-blue-800 mb-3">
              AGI Applications
            </h2>
            <p className="text-gray-600 mb-4">
              Implications and applications for artificial general intelligence 
              development using BTD principles.
            </p>
            <div className="text-blue-600 text-sm">
              Discover AGI applications →
            </div>
          </div>
        </div>

        {/* Additional Information */}
        <div className="mt-12 text-center text-gray-600">
          <p>
            By Sumanth Badigeru
          </p>
        </div>
      </div>
    </div>
  );
}

export default BTDLandingPage;